import axios from 'axios'
import qs from 'qs'

let baseURL
// 开发环境
if (process.env.NODE_ENV === 'development') {
  baseURL = ''
  // 编译环境
} else {
  // 测试环境
  if (process.env.type === 'test') {
    baseURL = ''
    // 预服环境
  } else if (process.env.type === 'pre') {
    baseURL = ''
    // 正式环境
  } else {
    baseURL = ''
  }
}
const request = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  timeout: 10000
})

export default {
  baseURL,
  // 课程列表数据
  getCoursesList: (params) => request.get('/youke2024/api/courses', qs.stringify(params)),
  // 课程排行数据
  getRankList: (params) => request.get('/youke2024/api/rank', qs.stringify(params)),
  // 专题统计数据
  getStatistics: (params) => request.get('/youke2024/api/statistics', qs.stringify(params)),
  //课程个人投票数据
  getUser_vote: (params) => request.get('/youke2024/api/user_vote', qs.stringify(params)),
  //课程投票数据
  getVote: (params) => request.post('/youke2024/api/vote', qs.stringify(params))
}


// WEBPACK FOOTER //
// ./src/api/index.js